import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Sample_Report_Table = ({ setEdit }) => {
  const data = [
    {
      sampleId: "ST1911202501",
      customerName: "Oshin Kawale",
      category: "Testing",
      desc: "Solid Fuel",
      sampleCount: "07",
      sampRecId: "Lab-1",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Rahul Mali",
      chemist: "R. Sharma",
      tat: "2 Days",
      priority: "Medium",
      status: "Scheduled",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST1911202502",
      customerName: "Swapnil Patil",
      category: "Calibration",
      desc: "Coal",
      sampleCount: "03",
      sampRecId: "Lab-2",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Sandhya Patil",
      chemist: "R. Sharma",
      tat: "6 Days",
      priority: "High",
      status: "In Progress",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST1911202503",
      customerName: "Tushar Rajput",
      category: "Calibration",
      desc: "Solid Fuel",
      sampleCount: "01",
      sampRecId: "Lab-3",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "24 JAN 2025",
      sampRecBy: "Rakhi Deshmukh",
      chemist: "R. Sharma",
      tat: "4 Days",
      priority: "Low",
      status: "Verified",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202504",
      customerName: "Prathamesh Raut",
      category: "Testing",
      desc: "Coal",
      sampleCount: "06",
      sampRecId: "Lab-4",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "25 JAN 2025",
      sampRecBy: "Saurav K.",
      chemist: "R. Sharma",
      tat: "2 Days",
      priority: "Medium",
      status: "Pending Review",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202505",
      customerName: "Prajwal Narkhede",
      category: "Calibration",
      desc: "Solid Fuel",
      sampleCount: "02",
      sampRecId: "Lab-5",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Kajal K.",
      chemist: "R. Sharma",
      tat: "6 Days",
      priority: "High",
      status: "Scheduled",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202506",
      customerName: "Sanket Thawari",
      category: "Testing",
      desc: "Coal",
      sampleCount: "04",
      sampRecId: "Lab-1",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Rahul Mali",
      chemist: "R. Sharma",
      tat: "4 Days",
      priority: "Medium",
      status: "In Progress",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202507",
      customerName: "Oshin Kawale",
      category: "Calibration",
      desc: "Coal",
      sampleCount: "03",
      sampRecId: "Lab-2",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "24 JAN 2025",
      sampRecBy: "Sandhya Patil",
      chemist: "R. Sharma",
      tat: "2 Days",
      priority: "Low",
      status: "Verified",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202508",
      customerName: "Swapnil Patil",
      category: "Calibration",
      desc: "Coal",
      sampleCount: "02",
      sampRecId: "Lab-3",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "25 JAN 2025",
      sampRecBy: "Rakhi Deshmukh",
      chemist: "R. Sharma",
      tat: "6 Days",
      priority: "Low",
      status: "Pending Review",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202509",
      customerName: "Tushar Rajput",
      category: "Testing",
      desc: "Solid Fuel",
      sampleCount: "08",
      sampRecId: "Lab-4",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Saurav K.",
      chemist: "R. Sharma",
      tat: "4 Days",
      priority: "Low",
      status: "Scheduled",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202510",
      customerName: "Prathamesh Raut",
      category: "Testing",
      desc: "Solid Fuel",
      sampleCount: "02",
      sampRecId: "Lab-5",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "23 JAN 2025",
      sampRecBy: "Kajal K.",
      chemist: "R. Sharma",
      tat: "2 Days",
      priority: "Medium",
      status: "In Progress",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202511",
      customerName: "Prajwal Narkhede",
      category: "Calibration",
      desc: "Solid Fuel",
      sampleCount: "04",
      sampRecId: "Lab-1",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "24 JAN 2025",
      sampRecBy: "Sandhya Patil",
      chemist: "R. Sharma",
      tat: "6 Days",
      priority: "High",
      status: "Verified",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202512",
      customerName: "Sanket Thawari",
      category: "Calibration",
      desc: "Coal",
      sampleCount: "03",
      sampRecId: "Lab-2",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "25 JAN 2025",
      sampRecBy: "Rakhi Deshmukh",
      chemist: "R. Sharma",
      tat: "4 Days",
      priority: "Low",
      status: "Pending Review",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202513",
      customerName: "Oshin Kawale",
      category: "Testing",
      desc: "Coal",
      sampleCount: "05",
      sampRecId: "Lab-3",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "26 JAN 2025",
      sampRecBy: "Rahul Mali",
      chemist: "R. Sharma",
      tat: "3 Days",
      priority: "Medium",
      status: "Scheduled",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202514",
      customerName: "Swapnil Patil",
      category: "Calibration",
      desc: "Solid Fuel",
      sampleCount: "01",
      sampRecId: "Lab-4",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "26 JAN 2025",
      sampRecBy: "Saurav K.",
      chemist: "R. Sharma",
      tat: "5 Days",
      priority: "Low",
      status: "Verified",
      authority: "Sanket M.",
    },
    {
      sampleId: "ST2011202515",
      customerName: "Tushar Rajput",
      category: "Testing",
      desc: "Coal",
      sampleCount: "06",
      sampRecId: "Lab-5",
      method: "IS 1350 (Part I): 2025",
      sampRecDate: "27 JAN 2025",
      sampRecBy: "Kajal K.",
      chemist: "R. Sharma",
      tat: "2 Days",
      priority: "High",
      status: "In Progress",
      authority: "Prachi Desai",
    },
    {
      sampleId: "ST2011202516",
      customerName: "Prathamesh Raut",
      category: "Calibration",
      desc: "Solid Fuel",
      sampleCount: "02",
      sampRecId: "Lab-1",
      method: "IS 1350 (Part II): 2022",
      sampRecDate: "27 JAN 2025",
      sampRecBy: "Sandhya Patil",
      chemist: "R. Sharma",
      tat: "6 Days",
      priority: "Medium",
      status: "Pending Review",
      authority: "Sanket M.",
    },
  ];
  const getStatusClass = (status) => {
  switch (status) {
    case "Scheduled":
      return "orange";
    case "In Progress":
      return "blue";
    case "Verified":
      return "green";
    case "Pending Review":
      return "red";
    default:
      return "";
  }
};

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Sample ID</th>
                <th>Customer Name</th>
                <th>Category</th>
                <th>DESC Of The Sample</th>
                <th>No. Of Sample</th>
                <th>SAMP. Rec. Id</th>
                <th>Method Of Testing</th>
                <th>SAMP. Rec. Date</th>
                <th>SAMP. Rec. By</th>
                <th>Chemist Assigned</th>
                <th>TAT (Days)</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Authority</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.sampleId}</td>
                  <td>{row.customerName}</td>
                  <td>{row.category}</td>
                  <td>{row.desc}</td>
                  <td>{row.sampleCount}</td>
                  <td>{row.sampRecId}</td>
                  <td>{row.method}</td>
                  <td>{row.sampRecDate}</td>
                  <td>{row.sampRecBy}</td>
                  <td>{row.chemist}</td>
                  <td>{row.tat}</td>
                   <td
                    className={
                      row.priority === "High"
                        ? "red"
                        : row.priority === "Medium"
                        ? "orange"
                        : "green"
                    }
                  >
                    {row.priority}
                  </td>
                 <td className={getStatusClass(row.status)}>{row.status}</td>
                  <td>{row.authority}</td>
                  {/* <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPencil} className="edit_icon" />
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Sample_Report_Table;
